
export interface EnteDto {
  ente: string;
  city?: string;
  address: string;
  provincia: string;
  regione: string;
  codice: string; //codicde catastale
  codiceLicenza: string; // codice cliente
  dataAttivazione: Date;
  dataProssimaScadenza: Date;
  id?: string;
  s3Url: string;
  s3AccessKey: string;
  s3SecretKey: string;
  isEnabled?: boolean;
  storage?: number;
  availableStorage?:number;
  users?: UserBase[];
  licenses?: License[];
  activeLicense: License;
}

export class EnteSubmitDto {
  ente: string;
  city: string;
  provincia: string;
  regione: string;
  codice: string;
  address: string;
  s3AccessKey: string;
  s3SecretKey: string;
  s3Bucket: string;
  s3Url: string;
  createdAt: Date;
  license: License;
}

export interface LicenseType {
  id: number
  name: string;
  maxStorage: number;
  maxCUP: number;
  hasPrioritySupport: boolean;
}
export interface License {
  startLicense: Date;
  endLicense: Date;
  licenseCode: string;
  licenseType: number;
  readonly isExpired?: boolean;
}

export interface UserList {
  users: UserBase[]
}

export interface UserBase {
  userName: string;
  emailConfirmed: boolean;
  roles: string;
}

export class UtenteAd {
  idUtente: number;
  email: string;
  convalida: Date;
  flagAttivo: boolean;

  constructor(idUtente: number, email: string, convalida: Date, flagAttivo: boolean,){
    this.idUtente = idUtente || 0; 
    this.email = email || ''; 
    this.convalida = convalida || new Date; 
    this.flagAttivo = flagAttivo || false;
  }
}
